import ProductRatingStars from "../../../shared/components/ProductRatingStars";
import PropTypes from "prop-types";
import React from "react";

const RatingsBreakdownDetail = ({
  starRating,
  starRatingCount,
  totalCount
}) => (
  <div className="breakdown-detail">
    <div>
      <ProductRatingStars
        averageRating={starRating}
        forGrid={false}
      />
      <span className="small">
        {`(${starRatingCount})`}
      </span>
    </div>
    <div className="meter">
      <span
        className="bar"
        style={{"width": `${(starRatingCount / totalCount) * 100}%`}}
      />
    </div>
  </div>
);

RatingsBreakdownDetail.propTypes = {
  "starRating": PropTypes.number.isRequired,
  "starRatingCount": PropTypes.number.isRequired,
  "totalCount": PropTypes.number.isRequired
};

export default RatingsBreakdownDetail;
